var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13.1468C2 13.0494 2.01421 12.9526 2.04217 12.8594L4.35861 5.13796C4.7393 3.869 5.90727 3 7.23209 3H16.7679C18.0927 3 19.2607 3.869 19.6414 5.13796L21.9578 12.8594C21.9858 12.9526 22 13.0494 22 13.1468V18C22 19.6569 20.6569 21 19 21H5C3.34315 21 2 19.6569 2 18V13.1468ZM16.7679 4H7.23209C6.34888 4 5.57023 4.57934 5.31644 5.4253L3.04403 13H8.38197C8.76074 13 9.107 13.214 9.27639 13.5528L9.99724 14.9945C9.99893 14.9979 10.0024 15 10.0062 15H13.9938C13.9976 15 14.0011 14.9979 14.0028 14.9945L14.7236 13.5528C14.893 13.214 15.2393 13 15.618 13H20.956L18.6836 5.4253C18.4298 4.57934 17.6511 4 16.7679 4ZM21 14H15.618L14.8972 15.4417C14.7261 15.7839 14.3764 16 13.9938 16H10.0062C9.62363 16 9.2739 15.7839 9.10281 15.4417L8.38197 14H3V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.c5bc85c56b65e80c20f4244ed33f0cec.svg";
export { ForwardRef as ReactComponent };